@file:OptIn(InternalResourceApi::class)

package heyagenda.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/heyagenda.shared.generated.resources/"

@delegate:ResourceContentHash(473_590_214)
internal val Res.drawable.train: DrawableResource by lazy {
      DrawableResource("drawable:train", setOf(
        ResourceItem(setOf(), "${MD}drawable/train.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(69_857_885)
internal val Res.drawable.train_regional: DrawableResource by lazy {
      DrawableResource("drawable:train_regional", setOf(
        ResourceItem(setOf(), "${MD}drawable/train_regional.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-61_463_890)
internal val Res.drawable.train_simple: DrawableResource by lazy {
      DrawableResource("drawable:train_simple", setOf(
        ResourceItem(setOf(), "${MD}drawable/train_simple.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_064_031_811)
internal val Res.drawable.tram: DrawableResource by lazy {
      DrawableResource("drawable:tram", setOf(
        ResourceItem(setOf(), "${MD}drawable/tram.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-471_113_488)
internal val Res.drawable.translate: DrawableResource by lazy {
      DrawableResource("drawable:translate", setOf(
        ResourceItem(setOf(), "${MD}drawable/translate.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(442_847_114)
internal val Res.drawable.trash: DrawableResource by lazy {
      DrawableResource("drawable:trash", setOf(
        ResourceItem(setOf(), "${MD}drawable/trash.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-170_833_097)
internal val Res.drawable.trash_simple: DrawableResource by lazy {
      DrawableResource("drawable:trash_simple", setOf(
        ResourceItem(setOf(), "${MD}drawable/trash_simple.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(504_596_045)
internal val Res.drawable.tray: DrawableResource by lazy {
      DrawableResource("drawable:tray", setOf(
        ResourceItem(setOf(), "${MD}drawable/tray.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-155_272_521)
internal val Res.drawable.tray_arrow_down: DrawableResource by lazy {
      DrawableResource("drawable:tray_arrow_down", setOf(
        ResourceItem(setOf(), "${MD}drawable/tray_arrow_down.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(998_302_385)
internal val Res.drawable.tray_arrow_up: DrawableResource by lazy {
      DrawableResource("drawable:tray_arrow_up", setOf(
        ResourceItem(setOf(), "${MD}drawable/tray_arrow_up.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_937_631_317)
internal val Res.drawable.treasure_chest: DrawableResource by lazy {
      DrawableResource("drawable:treasure_chest", setOf(
        ResourceItem(setOf(), "${MD}drawable/treasure_chest.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_732_916_069)
internal val Res.drawable.tree: DrawableResource by lazy {
      DrawableResource("drawable:tree", setOf(
        ResourceItem(setOf(), "${MD}drawable/tree.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_838_118_010)
internal val Res.drawable.tree_evergreen: DrawableResource by lazy {
      DrawableResource("drawable:tree_evergreen", setOf(
        ResourceItem(setOf(), "${MD}drawable/tree_evergreen.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-598_711_862)
internal val Res.drawable.tree_palm: DrawableResource by lazy {
      DrawableResource("drawable:tree_palm", setOf(
        ResourceItem(setOf(), "${MD}drawable/tree_palm.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_110_372_168)
internal val Res.drawable.tree_structure: DrawableResource by lazy {
      DrawableResource("drawable:tree_structure", setOf(
        ResourceItem(setOf(), "${MD}drawable/tree_structure.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-503_575_660)
internal val Res.drawable.tree_view: DrawableResource by lazy {
      DrawableResource("drawable:tree_view", setOf(
        ResourceItem(setOf(), "${MD}drawable/tree_view.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_200_262_528)
internal val Res.drawable.trend: DrawableResource by lazy {
      DrawableResource("drawable:trend", setOf(
        ResourceItem(setOf(), "${MD}drawable/trend.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_052_400_043)
internal val Res.drawable.trend_down: DrawableResource by lazy {
      DrawableResource("drawable:trend_down", setOf(
        ResourceItem(setOf(), "${MD}drawable/trend_down.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_489_049_659)
internal val Res.drawable.triangle: DrawableResource by lazy {
      DrawableResource("drawable:triangle", setOf(
        ResourceItem(setOf(), "${MD}drawable/triangle.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_788_520_154)
internal val Res.drawable.triangle_dashed: DrawableResource by lazy {
      DrawableResource("drawable:triangle_dashed", setOf(
        ResourceItem(setOf(), "${MD}drawable/triangle_dashed.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_069_759_420)
internal val Res.drawable.trolley: DrawableResource by lazy {
      DrawableResource("drawable:trolley", setOf(
        ResourceItem(setOf(), "${MD}drawable/trolley.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_382_353_275)
internal val Res.drawable.trolley_suitcase: DrawableResource by lazy {
      DrawableResource("drawable:trolley_suitcase", setOf(
        ResourceItem(setOf(), "${MD}drawable/trolley_suitcase.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_314_293_638)
internal val Res.drawable.trophy: DrawableResource by lazy {
      DrawableResource("drawable:trophy", setOf(
        ResourceItem(setOf(), "${MD}drawable/trophy.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_353_338_741)
internal val Res.drawable.truck: DrawableResource by lazy {
      DrawableResource("drawable:truck", setOf(
        ResourceItem(setOf(), "${MD}drawable/truck.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(270_325_334)
internal val Res.drawable.truck_trailer: DrawableResource by lazy {
      DrawableResource("drawable:truck_trailer", setOf(
        ResourceItem(setOf(), "${MD}drawable/truck_trailer.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_895_279_325)
internal val Res.drawable.tumblr_logo: DrawableResource by lazy {
      DrawableResource("drawable:tumblr_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/tumblr_logo.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_096_633_983)
internal val Res.drawable.twitch_logo: DrawableResource by lazy {
      DrawableResource("drawable:twitch_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/twitch_logo.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_397_972_520)
internal val Res.drawable.twitter_logo: DrawableResource by lazy {
      DrawableResource("drawable:twitter_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/twitter_logo.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_250_901_279)
internal val Res.drawable.umbrella: DrawableResource by lazy {
      DrawableResource("drawable:umbrella", setOf(
        ResourceItem(setOf(), "${MD}drawable/umbrella.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-329_695_759)
internal val Res.drawable.umbrella_simple: DrawableResource by lazy {
      DrawableResource("drawable:umbrella_simple", setOf(
        ResourceItem(setOf(), "${MD}drawable/umbrella_simple.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(917_686_966)
internal val Res.drawable.union: DrawableResource by lazy {
      DrawableResource("drawable:union", setOf(
        ResourceItem(setOf(), "${MD}drawable/union.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(503_970_184)
internal val Res.drawable.unite: DrawableResource by lazy {
      DrawableResource("drawable:unite", setOf(
        ResourceItem(setOf(), "${MD}drawable/unite.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_594_959_702)
internal val Res.drawable.upload: DrawableResource by lazy {
      DrawableResource("drawable:upload", setOf(
        ResourceItem(setOf(), "${MD}drawable/upload.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_599_299_106)
internal val Res.drawable.upload_simple: DrawableResource by lazy {
      DrawableResource("drawable:upload_simple", setOf(
        ResourceItem(setOf(), "${MD}drawable/upload_simple.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-494_422_802)
internal val Res.drawable.usb: DrawableResource by lazy {
      DrawableResource("drawable:usb", setOf(
        ResourceItem(setOf(), "${MD}drawable/usb.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_405_895_845)
internal val Res.drawable.user: DrawableResource by lazy {
      DrawableResource("drawable:user", setOf(
        ResourceItem(setOf(), "${MD}drawable/user.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-728_702_533)
internal val Res.drawable.user_check: DrawableResource by lazy {
      DrawableResource("drawable:user_check", setOf(
        ResourceItem(setOf(), "${MD}drawable/user_check.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-137_860_272)
internal val Res.drawable.user_circle: DrawableResource by lazy {
      DrawableResource("drawable:user_circle", setOf(
        ResourceItem(setOf(), "${MD}drawable/user_circle.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_818_129_076)
internal val Res.drawable.user_circle_check: DrawableResource by lazy {
      DrawableResource("drawable:user_circle_check", setOf(
        ResourceItem(setOf(), "${MD}drawable/user_circle_check.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_705_584_179)
internal val Res.drawable.user_circle_dashed: DrawableResource by lazy {
      DrawableResource("drawable:user_circle_dashed", setOf(
        ResourceItem(setOf(), "${MD}drawable/user_circle_dashed.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(645_830_281)
internal val Res.drawable.user_circle_gear: DrawableResource by lazy {
      DrawableResource("drawable:user_circle_gear", setOf(
        ResourceItem(setOf(), "${MD}drawable/user_circle_gear.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_956_122_795)
internal val Res.drawable.user_circle_minus: DrawableResource by lazy {
      DrawableResource("drawable:user_circle_minus", setOf(
        ResourceItem(setOf(), "${MD}drawable/user_circle_minus.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_147_368_258)
internal val Res.drawable.user_circle_plus: DrawableResource by lazy {
      DrawableResource("drawable:user_circle_plus", setOf(
        ResourceItem(setOf(), "${MD}drawable/user_circle_plus.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_677_735_289)
internal val Res.drawable.user_focus: DrawableResource by lazy {
      DrawableResource("drawable:user_focus", setOf(
        ResourceItem(setOf(), "${MD}drawable/user_focus.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_618_785_000)
internal val Res.drawable.user_gear: DrawableResource by lazy {
      DrawableResource("drawable:user_gear", setOf(
        ResourceItem(setOf(), "${MD}drawable/user_gear.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(331_720_288)
internal val Res.drawable.user_list: DrawableResource by lazy {
      DrawableResource("drawable:user_list", setOf(
        ResourceItem(setOf(), "${MD}drawable/user_list.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(283_333_567)
internal val Res.drawable.user_minus: DrawableResource by lazy {
      DrawableResource("drawable:user_minus", setOf(
        ResourceItem(setOf(), "${MD}drawable/user_minus.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-534_477_626)
internal val Res.drawable.user_plus: DrawableResource by lazy {
      DrawableResource("drawable:user_plus", setOf(
        ResourceItem(setOf(), "${MD}drawable/user_plus.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_125_879_709)
internal val Res.drawable.user_rectangle: DrawableResource by lazy {
      DrawableResource("drawable:user_rectangle", setOf(
        ResourceItem(setOf(), "${MD}drawable/user_rectangle.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-442_134_828)
internal val Res.drawable.user_sound: DrawableResource by lazy {
      DrawableResource("drawable:user_sound", setOf(
        ResourceItem(setOf(), "${MD}drawable/user_sound.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-84_727_556)
internal val Res.drawable.user_switch: DrawableResource by lazy {
      DrawableResource("drawable:user_switch", setOf(
        ResourceItem(setOf(), "${MD}drawable/user_switch.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_553_246_043)
internal val Res.drawable.users: DrawableResource by lazy {
      DrawableResource("drawable:users", setOf(
        ResourceItem(setOf(), "${MD}drawable/users.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_233_303_736)
internal val Res.drawable.users_three: DrawableResource by lazy {
      DrawableResource("drawable:users_three", setOf(
        ResourceItem(setOf(), "${MD}drawable/users_three.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-901_939_819)
internal val Res.drawable.van: DrawableResource by lazy {
      DrawableResource("drawable:van", setOf(
        ResourceItem(setOf(), "${MD}drawable/van.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_419_500_708)
internal val Res.drawable.vault: DrawableResource by lazy {
      DrawableResource("drawable:vault", setOf(
        ResourceItem(setOf(), "${MD}drawable/vault.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_030_679_031)
internal val Res.drawable.vector: DrawableResource by lazy {
      DrawableResource("drawable:vector", setOf(
        ResourceItem(setOf(), "${MD}drawable/vector.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-103_287_101)
internal val Res.drawable.vector_three: DrawableResource by lazy {
      DrawableResource("drawable:vector_three", setOf(
        ResourceItem(setOf(), "${MD}drawable/vector_three.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_950_532_295)
internal val Res.drawable.vibrate: DrawableResource by lazy {
      DrawableResource("drawable:vibrate", setOf(
        ResourceItem(setOf(), "${MD}drawable/vibrate.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_553_845_859)
internal val Res.drawable.video: DrawableResource by lazy {
      DrawableResource("drawable:video", setOf(
        ResourceItem(setOf(), "${MD}drawable/video.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(524_595_151)
internal val Res.drawable.video_camera: DrawableResource by lazy {
      DrawableResource("drawable:video_camera", setOf(
        ResourceItem(setOf(), "${MD}drawable/video_camera.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-577_616_756)
internal val Res.drawable.video_camera_slash: DrawableResource by lazy {
      DrawableResource("drawable:video_camera_slash", setOf(
        ResourceItem(setOf(), "${MD}drawable/video_camera_slash.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_139_509_288)
internal val Res.drawable.video_conference: DrawableResource by lazy {
      DrawableResource("drawable:video_conference", setOf(
        ResourceItem(setOf(), "${MD}drawable/video_conference.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_248_313_472)
internal val Res.drawable.vignette: DrawableResource by lazy {
      DrawableResource("drawable:vignette", setOf(
        ResourceItem(setOf(), "${MD}drawable/vignette.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-946_613_383)
internal val Res.drawable.vinyl_record: DrawableResource by lazy {
      DrawableResource("drawable:vinyl_record", setOf(
        ResourceItem(setOf(), "${MD}drawable/vinyl_record.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_017_845_556)
internal val Res.drawable.virtual_reality: DrawableResource by lazy {
      DrawableResource("drawable:virtual_reality", setOf(
        ResourceItem(setOf(), "${MD}drawable/virtual_reality.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-252_046_988)
internal val Res.drawable.virus: DrawableResource by lazy {
      DrawableResource("drawable:virus", setOf(
        ResourceItem(setOf(), "${MD}drawable/virus.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(216_058_246)
internal val Res.drawable.visor: DrawableResource by lazy {
      DrawableResource("drawable:visor", setOf(
        ResourceItem(setOf(), "${MD}drawable/visor.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_437_043_036)
internal val Res.drawable.voicemail: DrawableResource by lazy {
      DrawableResource("drawable:voicemail", setOf(
        ResourceItem(setOf(), "${MD}drawable/voicemail.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_419_202_871)
internal val Res.drawable.volleyball: DrawableResource by lazy {
      DrawableResource("drawable:volleyball", setOf(
        ResourceItem(setOf(), "${MD}drawable/volleyball.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_721_115_942)
internal val Res.drawable.wall: DrawableResource by lazy {
      DrawableResource("drawable:wall", setOf(
        ResourceItem(setOf(), "${MD}drawable/wall.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_338_927_102)
internal val Res.drawable.wallet: DrawableResource by lazy {
      DrawableResource("drawable:wallet", setOf(
        ResourceItem(setOf(), "${MD}drawable/wallet.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_374_227_781)
internal val Res.drawable.warehouse: DrawableResource by lazy {
      DrawableResource("drawable:warehouse", setOf(
        ResourceItem(setOf(), "${MD}drawable/warehouse.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(815_116_334)
internal val Res.drawable.warning: DrawableResource by lazy {
      DrawableResource("drawable:warning", setOf(
        ResourceItem(setOf(), "${MD}drawable/warning.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(889_672_280)
internal val Res.drawable.warning_circle: DrawableResource by lazy {
      DrawableResource("drawable:warning_circle", setOf(
        ResourceItem(setOf(), "${MD}drawable/warning_circle.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-982_065_603)
internal val Res.drawable.warning_diamond: DrawableResource by lazy {
      DrawableResource("drawable:warning_diamond", setOf(
        ResourceItem(setOf(), "${MD}drawable/warning_diamond.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-862_531_997)
internal val Res.drawable.warning_octagon: DrawableResource by lazy {
      DrawableResource("drawable:warning_octagon", setOf(
        ResourceItem(setOf(), "${MD}drawable/warning_octagon.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-417_561_735)
internal val Res.drawable.washing_machine: DrawableResource by lazy {
      DrawableResource("drawable:washing_machine", setOf(
        ResourceItem(setOf(), "${MD}drawable/washing_machine.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(241_827_802)
internal val Res.drawable.watch: DrawableResource by lazy {
      DrawableResource("drawable:watch", setOf(
        ResourceItem(setOf(), "${MD}drawable/watch.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(613_937_738)
internal val Res.drawable.wave_sawtooth: DrawableResource by lazy {
      DrawableResource("drawable:wave_sawtooth", setOf(
        ResourceItem(setOf(), "${MD}drawable/wave_sawtooth.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(888_357_527)
internal val Res.drawable.wave_sine: DrawableResource by lazy {
      DrawableResource("drawable:wave_sine", setOf(
        ResourceItem(setOf(), "${MD}drawable/wave_sine.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(915_611_773)
internal val Res.drawable.wave_triangle: DrawableResource by lazy {
      DrawableResource("drawable:wave_triangle", setOf(
        ResourceItem(setOf(), "${MD}drawable/wave_triangle.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_355_231_355)
internal val Res.drawable.waveform: DrawableResource by lazy {
      DrawableResource("drawable:waveform", setOf(
        ResourceItem(setOf(), "${MD}drawable/waveform.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-64_784_113)
internal val Res.drawable.waveform_slash: DrawableResource by lazy {
      DrawableResource("drawable:waveform_slash", setOf(
        ResourceItem(setOf(), "${MD}drawable/waveform_slash.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_453_280_816)
internal val Res.drawable.waves: DrawableResource by lazy {
      DrawableResource("drawable:waves", setOf(
        ResourceItem(setOf(), "${MD}drawable/waves.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_995_577_995)
internal val Res.drawable.webcam: DrawableResource by lazy {
      DrawableResource("drawable:webcam", setOf(
        ResourceItem(setOf(), "${MD}drawable/webcam.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_380_305_194)
internal val Res.drawable.webcam_slash: DrawableResource by lazy {
      DrawableResource("drawable:webcam_slash", setOf(
        ResourceItem(setOf(), "${MD}drawable/webcam_slash.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(309_412_899)
internal val Res.drawable.webhooks_logo: DrawableResource by lazy {
      DrawableResource("drawable:webhooks_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/webhooks_logo.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_899_826_487)
internal val Res.drawable.wechat_logo: DrawableResource by lazy {
      DrawableResource("drawable:wechat_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/wechat_logo.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-300_228_523)
internal val Res.drawable.whatsapp_logo: DrawableResource by lazy {
      DrawableResource("drawable:whatsapp_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/whatsapp_logo.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(133_330_166)
internal val Res.drawable.wheelchair: DrawableResource by lazy {
      DrawableResource("drawable:wheelchair", setOf(
        ResourceItem(setOf(), "${MD}drawable/wheelchair.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-851_709_476)
internal val Res.drawable.wheelchair_motion: DrawableResource by lazy {
      DrawableResource("drawable:wheelchair_motion", setOf(
        ResourceItem(setOf(), "${MD}drawable/wheelchair_motion.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(986_723_931)
internal val Res.drawable.wifi: DrawableResource by lazy {
      DrawableResource("drawable:wifi", setOf(
        ResourceItem(setOf(), "${MD}drawable/wifi.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_872_946_329)
internal val Res.drawable.wifi_high: DrawableResource by lazy {
      DrawableResource("drawable:wifi_high", setOf(
        ResourceItem(setOf(), "${MD}drawable/wifi_high.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-176_841_502)
internal val Res.drawable.wifi_medium: DrawableResource by lazy {
      DrawableResource("drawable:wifi_medium", setOf(
        ResourceItem(setOf(), "${MD}drawable/wifi_medium.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(643_675_014)
internal val Res.drawable.wifi_none: DrawableResource by lazy {
      DrawableResource("drawable:wifi_none", setOf(
        ResourceItem(setOf(), "${MD}drawable/wifi_none.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_848_946_117)
internal val Res.drawable.wifi_slash: DrawableResource by lazy {
      DrawableResource("drawable:wifi_slash", setOf(
        ResourceItem(setOf(), "${MD}drawable/wifi_slash.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(557_607_647)
internal val Res.drawable.wifi_x: DrawableResource by lazy {
      DrawableResource("drawable:wifi_x", setOf(
        ResourceItem(setOf(), "${MD}drawable/wifi_x.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(271_676_667)
internal val Res.drawable.wind: DrawableResource by lazy {
      DrawableResource("drawable:wind", setOf(
        ResourceItem(setOf(), "${MD}drawable/wind.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_386_449_297)
internal val Res.drawable.windmill: DrawableResource by lazy {
      DrawableResource("drawable:windmill", setOf(
        ResourceItem(setOf(), "${MD}drawable/windmill.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(719_520_715)
internal val Res.drawable.windows_logo: DrawableResource by lazy {
      DrawableResource("drawable:windows_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/windows_logo.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable12Resources(map: MutableMap<String, DrawableResource>) {
  map.put("train", Res.drawable.train)
  map.put("train_regional", Res.drawable.train_regional)
  map.put("train_simple", Res.drawable.train_simple)
  map.put("tram", Res.drawable.tram)
  map.put("translate", Res.drawable.translate)
  map.put("trash", Res.drawable.trash)
  map.put("trash_simple", Res.drawable.trash_simple)
  map.put("tray", Res.drawable.tray)
  map.put("tray_arrow_down", Res.drawable.tray_arrow_down)
  map.put("tray_arrow_up", Res.drawable.tray_arrow_up)
  map.put("treasure_chest", Res.drawable.treasure_chest)
  map.put("tree", Res.drawable.tree)
  map.put("tree_evergreen", Res.drawable.tree_evergreen)
  map.put("tree_palm", Res.drawable.tree_palm)
  map.put("tree_structure", Res.drawable.tree_structure)
  map.put("tree_view", Res.drawable.tree_view)
  map.put("trend", Res.drawable.trend)
  map.put("trend_down", Res.drawable.trend_down)
  map.put("triangle", Res.drawable.triangle)
  map.put("triangle_dashed", Res.drawable.triangle_dashed)
  map.put("trolley", Res.drawable.trolley)
  map.put("trolley_suitcase", Res.drawable.trolley_suitcase)
  map.put("trophy", Res.drawable.trophy)
  map.put("truck", Res.drawable.truck)
  map.put("truck_trailer", Res.drawable.truck_trailer)
  map.put("tumblr_logo", Res.drawable.tumblr_logo)
  map.put("twitch_logo", Res.drawable.twitch_logo)
  map.put("twitter_logo", Res.drawable.twitter_logo)
  map.put("umbrella", Res.drawable.umbrella)
  map.put("umbrella_simple", Res.drawable.umbrella_simple)
  map.put("union", Res.drawable.union)
  map.put("unite", Res.drawable.unite)
  map.put("upload", Res.drawable.upload)
  map.put("upload_simple", Res.drawable.upload_simple)
  map.put("usb", Res.drawable.usb)
  map.put("user", Res.drawable.user)
  map.put("user_check", Res.drawable.user_check)
  map.put("user_circle", Res.drawable.user_circle)
  map.put("user_circle_check", Res.drawable.user_circle_check)
  map.put("user_circle_dashed", Res.drawable.user_circle_dashed)
  map.put("user_circle_gear", Res.drawable.user_circle_gear)
  map.put("user_circle_minus", Res.drawable.user_circle_minus)
  map.put("user_circle_plus", Res.drawable.user_circle_plus)
  map.put("user_focus", Res.drawable.user_focus)
  map.put("user_gear", Res.drawable.user_gear)
  map.put("user_list", Res.drawable.user_list)
  map.put("user_minus", Res.drawable.user_minus)
  map.put("user_plus", Res.drawable.user_plus)
  map.put("user_rectangle", Res.drawable.user_rectangle)
  map.put("user_sound", Res.drawable.user_sound)
  map.put("user_switch", Res.drawable.user_switch)
  map.put("users", Res.drawable.users)
  map.put("users_three", Res.drawable.users_three)
  map.put("van", Res.drawable.van)
  map.put("vault", Res.drawable.vault)
  map.put("vector", Res.drawable.vector)
  map.put("vector_three", Res.drawable.vector_three)
  map.put("vibrate", Res.drawable.vibrate)
  map.put("video", Res.drawable.video)
  map.put("video_camera", Res.drawable.video_camera)
  map.put("video_camera_slash", Res.drawable.video_camera_slash)
  map.put("video_conference", Res.drawable.video_conference)
  map.put("vignette", Res.drawable.vignette)
  map.put("vinyl_record", Res.drawable.vinyl_record)
  map.put("virtual_reality", Res.drawable.virtual_reality)
  map.put("virus", Res.drawable.virus)
  map.put("visor", Res.drawable.visor)
  map.put("voicemail", Res.drawable.voicemail)
  map.put("volleyball", Res.drawable.volleyball)
  map.put("wall", Res.drawable.wall)
  map.put("wallet", Res.drawable.wallet)
  map.put("warehouse", Res.drawable.warehouse)
  map.put("warning", Res.drawable.warning)
  map.put("warning_circle", Res.drawable.warning_circle)
  map.put("warning_diamond", Res.drawable.warning_diamond)
  map.put("warning_octagon", Res.drawable.warning_octagon)
  map.put("washing_machine", Res.drawable.washing_machine)
  map.put("watch", Res.drawable.watch)
  map.put("wave_sawtooth", Res.drawable.wave_sawtooth)
  map.put("wave_sine", Res.drawable.wave_sine)
  map.put("wave_triangle", Res.drawable.wave_triangle)
  map.put("waveform", Res.drawable.waveform)
  map.put("waveform_slash", Res.drawable.waveform_slash)
  map.put("waves", Res.drawable.waves)
  map.put("webcam", Res.drawable.webcam)
  map.put("webcam_slash", Res.drawable.webcam_slash)
  map.put("webhooks_logo", Res.drawable.webhooks_logo)
  map.put("wechat_logo", Res.drawable.wechat_logo)
  map.put("whatsapp_logo", Res.drawable.whatsapp_logo)
  map.put("wheelchair", Res.drawable.wheelchair)
  map.put("wheelchair_motion", Res.drawable.wheelchair_motion)
  map.put("wifi", Res.drawable.wifi)
  map.put("wifi_high", Res.drawable.wifi_high)
  map.put("wifi_medium", Res.drawable.wifi_medium)
  map.put("wifi_none", Res.drawable.wifi_none)
  map.put("wifi_slash", Res.drawable.wifi_slash)
  map.put("wifi_x", Res.drawable.wifi_x)
  map.put("wind", Res.drawable.wind)
  map.put("windmill", Res.drawable.windmill)
  map.put("windows_logo", Res.drawable.windows_logo)
}
